import { observable, action, computed } from 'mobx';
import { Contragent } from 'api';

class ContragentStore {
  @observable _contragent;

  @observable fetchState;

  anketId;

  @computed
  get contragentInfo() {
    return this._contragent;
  }

  @action.bound
  setContragentInfo(contragent) {
    this._contragent = contragent;
  }

  @action.bound
  async getContragentInfo(anketId) {
    if (this.anketId === anketId) {
      return;
    }

    this.fetchState = 'pending';

    try {
      const response = await Contragent.getContragentInfo(anketId);
      this.setContragentInfo(response.data);
      this.fetchState = 'fulfilled';
      this.anketId = anketId;
    } catch (e) {
      this.fetchState = 'rejected';
      console.log(`Can't fetch contragent info from remote server`, e); // eslint-disable-line
    }
  }
}

const contragentStore = new ContragentStore();

export default contragentStore;
